import React from "react";
import PraiseImage from "./../assets/testimonials/praiseessu.jpg";
import IbiImage from "./../assets/testimonials/oganibi.jpg";

const Testimonials = () => {
  return (
    <div className="bg-cream mt-24 md:py-24 md:px-20 px-8 py-12">
      <h2 className="text-center font-bold text-3xl md:text-4xl text-dark-blue mb-10">
        What our customers are saying
      </h2>
      <div className="flex justify-center items-center flex-col md:flex-row gap-8">
        <div className="bg-white px-6 py-8 w-full md:w-1/3">
          <p>
            Amazing quality. Very good packaging. It meets my expectation -
            sermon notes, personal study. 100% recommend.
          </p>
          <div className="mt-8 flex gap-4">
            <div>
              <img
                src={PraiseImage}
                alt="Praise testimony"
                className="rounded-full w-16 h-16"
              />
            </div>
            <div className="self-center">
              <h3>Praise Essu</h3>
              <p className="text-gray-500 text-sm">
                Medical Student, Edo State University
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white px-6 py-8 w-full md:w-1/3">
          <p>
            Great quality and excellent design. I've copped my copies already
            and you should too. Can't wait to get writing.
          </p>
          <div className="mt-8 flex gap-4">
            <div>
              <img
                src={IbiImage}
                alt="Praise testimony"
                className="rounded-full w-16 h-16"
              />
            </div>
            <div className="self-center">
              <h3>Ibi Ogan</h3>
              <p className="text-gray-500 text-sm">Software Developer</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
